module.exports = __webpack_public_path__ + "img/lts-wt-fr.f29e5008.png";